import styled from "styled-components";

export const StyledResolutionNotes = styled.div`
  display: grid;
  gap: 10px;
  margin: ${(props) => props.margin || "0"};

  .v2-resolution-note-card {
    padding: 14px;
    background: var(--rms-v2-surface);
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    color: var(--rms-v2-text-muted);
    font-size: 13px;
  }

  .v2-resolution-note-title {
    margin: 0 0 8px;
    color: var(--rms-v2-text-title);
    font-size: 13px;
    font-weight: 800;
  }

  .v2-resolution-note-content,
  .v2-resolution-note-content p,
  .v2-resolution-note-content li {
    color: var(--rms-v2-text-muted);
    font-size: 12px;
  }

  .v2-resolution-note-content p {
    margin: 0 0 6px;
  }

  .v2-resolution-note-content p:last-child {
    margin-bottom: 0;
  }

  .v2-resolution-note-content ul,
  .v2-resolution-note-content ol {
    margin: 0;
    padding-left: 18px;
  }
`;
